import { FormattedMessage } from 'react-intl';
import Icon from '../../components/Icon';
import { useTheme } from 'styled-components';

const ExpandItem = ({ handleToggleOpen, isOpen }) => {
  const theme = useTheme();

  return (
    <div
      className="d-flex align-items-center"
      style={{ paddingLeft: 8, paddingRight: 8, height: 58 }}
    >
      <div
        className="left-navbar-button d-flex"
        onClick={handleToggleOpen}
        style={{
          width: isOpen ? 284 : 42,
        }}
      >
        <div
          style={{ width: 42, height: 42 }}
          className="d-flex align-items-center justify-content-center"
        >
          {isOpen && (
            <div>
              <Icon
                name="chevron-left-outline"
                color={theme.colors.whiteColor}
              />
            </div>
          )}
          {!isOpen && (
            <div>
              <Icon
                name="chevron-right-outline"
                color={theme.colors.whiteColor}
              />
            </div>
          )}
        </div>

        {isOpen && (
          <div
            className="d-flex align-items-center"
            style={{
              fontWeight: 500,
              flexGrow: 1,
              color: 'white',
              fontSize: 14,
            }}
          >
            <FormattedMessage defaultMessage="Minimera menyn" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpandItem;
